module.exports = __webpack_public_path__ + "static/img/manual-6.fb743ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-6.png
// module id = SkRO
// module chunks = 4